export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更預告_tc-531de1ebecfd4acda37d129629c663aa.png";